import { createContext } from "react";

const UnitContext = createContext({
  units: {},
  metric: {},
  imperial: {},
  metricSymbols: () => {},
  bothSymbols: () => {},
  imperialSymbols: () => {},
  updateUint: (unit) => {},
});

export function UnitContextProvider(props) {
  function unit(names, symbol, convertTo) {
    return {
      names: names,
      symbol: symbol,
      convertTo: convertTo,
    };
  }

  const metric = {
    kilograms: unit(
      ["kilograms", "kilogram", "kilos", "kilo", "kgs", "kg"],
      "kg",
      {
        grams: (value) => { return value * 1000; },
        pounds: (value) => { return value * 2.205; },
        ounces: (value) => { return value *  35.274; },
      }
    ),
    grams: unit(
      ["grams", "gram", "g"], 
      "g", 
      {
        kilograms: (value) => { return value / 1000; },
        pounds: (value) => { return value * 0.0022046; },
        ounces: (value) => { return value * 0.035274; },
      }
    ),
    liters: unit(
      ["liters", "liter", "l"], 
      "L",
      {
        milliliters: (value) => { return value * 1000; },
        gallons: (value) => { return value / 3.785; },
        fluidOunces: (value) => { return value * 33.814; },
        quarts: (value) => { return value * 1.057; },
        pints: (value) => { return value * 2.113; },

      }
    ),
    milliliters: unit(
      ["milliliters", "milliliter", "mls", "ml"], 
      "mL",
      {
        liters: (value) => { return value / 1000; },
        gallons: (value) => { return value / 3785; },
        fluidOunces: (value) => { return value / 29.574; },
        quarts: (value) => { return value / 946.4; },
        pints: (value) => { return value / 473.2; },
      }
    ),
    cups: unit(["cups", "cup", "c"], "cup"),
    teaspoons: unit(
      ["teaspoons", "teaspoon", "tspns", "tsps", "tspn", "tsp"],
      "tsp"
    ),
    tablespoons: unit(["tablespoons", "tablespoon", "tbsp"], "tbsp"),
  };

  const imperial = {
    pounds: unit(
      ["pounds", "pound", "lbs", "lb"], 
      "lb",
      {
        ounces: (value) => { return value * 16; },
        grams: (value) => { return value * 453.6; },
        kilograms: (value) => { return value / 2.205; },
      }
    ),
    ounces: unit(
      ["ounces", "ounce", "ozs", "oz"], 
      "oz",
      {
        pounds: (value) => { return value / 16; },
        grams: (value) => { return value * 28.35; },
        kilograms: (value) => { return value / 35.274; },
      }
    ),
    gallons: unit(
      ["gallons", "gallon", "gal"], 
      "gal",
      {
        pints: (value) => { return value * 8; },
        quarts: (value) => { return value * 4; },
        fluidOunces: (value) => { return value * 128; },
        liters: (value) => { return value * 3.785; },
        milliliters: (value) => { return value * 3785; },
      }
    ),
    pints: unit(
      ["pints", "pint", "pt"], 
      "pt",
      {
        gallons: (value) => { return value / 8; },
        quarts: (value) => { return value / 2; },
        fluidOunces: (value) => { return value / 16; },
        liters: (value) => { return value / 2.113; },
        milliliters: (value) => { return value * 473.2; },
      }
    ),
    quarts: unit(
      ["quarts", "quart", "qt"], 
      "qt",
      {
        gallons: (value) => { return value / 4; },
        pints: (value) => { return value * 2; },
        fluidOunces: (value) => { return value * 32; },
        liters: (value) => { return value / 1.057; },
        milliliters: (value) => { return value * 946.4; },
      }
    ),
    fluidOunces: unit(
      ["fluid ounces", "fluid ounce", "fl. oz.", "fl oz"],
      "fl oz",
      {
        gallons: (value) => { return value / 128; },
        pints: (value) => { return value / 16; },
        quarts: (value) => { return value / 32; },
        liters: (value) => { return value / 33.814; },
        milliliters: (value) => { return value * 29.574; },
      }
    ),
    cups: unit(["cups", "cup", "c"], "cup"),
    teaspoons: unit(
      ["teaspoons", "teaspoon", "tspns", "tsps", "tspn", "tsp"],
      "tsp"
    ),
    tablespoons: unit(["tablespoons", "tablespoon", "tbsp", "tbspn"], "tbsp"),
  };

  const shared = {
    times: unit(["x"], "x"),
  };

  const units = {
    kilograms: metric.kilograms.names,
    grams: metric.grams.names,
    liters: metric.liters.names,
    milliliters: metric.milliliters.names,
    pounds: imperial.pounds.names,
    ounces: imperial.ounces.names,
    gallons: imperial.gallons.names,
    pints: imperial.pints.names,
    quarts: imperial.quarts.names,
    fluidOunces: imperial.fluidOunces.names,
    cups: metric.cups.names,
    teaspoons: metric.teaspoons.names,
    tablespoons: metric.tablespoons.names,
    times: shared.times.names,
  };

  function metricSymbols() {
    var sysmbols = [];
    Object.entries(metric).forEach(([key, unit]) => {
      sysmbols.push(unit.symbol);
    });
    console.log(sysmbols);
    return sysmbols;
  }

  function imperialSymbols() {
    var sysmbols = [];
    Object.entries(imperial).forEach(([key, unit]) => {
      sysmbols.push(unit.symbol);
    });
    return sysmbols;
  }

  function bothSymbols() {
    var sysmbols = [
      metric.grams.symbol,
      metric.kilograms.symbol,
      metric.milliliters.symbol,
      metric.liters.symbol,
    ];
    Object.entries(imperial).forEach(([key, unit]) => {
      sysmbols.push(unit.symbol);
    });
    return sysmbols;
  }

  function updateUint(inputUnit) {
    var unit = inputUnit.toLowerCase()
    if (units.times.includes(unit)) {
      unit = "x";
    } else if (units.pounds.includes(unit)) {
      unit = "lb";
    } else if (units.ounces.includes(unit)) {
      unit = "oz";
    } else if (units.kilograms.includes(unit)) {
      unit = "kg";
    } else if (units.gallons.includes(unit)) {
      unit = "gal";
    } else if (units.grams.includes(unit)) {
      unit = "g";
    } else if (units.pints.includes(unit)) {
      unit = "pt";
    } else if (units.quarts.includes(unit)) {
      unit = "qt";
    } else if (units.fluidOunces.includes(unit)) {
      unit = "fl oz";
    } else if (units.liters.includes(unit)) {
      unit = "L";
    } else if (units.cups.includes(unit)) {
      unit = "cup";
    } else if (units.milliliters.includes(unit)) {
      unit = "mL";
    } else if (units.teaspoons.includes(unit)) {
      unit = "tsp";
    } else if (units.tablespoons.includes(unit)) {
      unit = "tbsp";
    }
    return unit;
  }

  const context = {
    units: units,
    metric: metric,
    imperial: imperial,
    updateUint: updateUint,
    metricSymbols: metricSymbols,
    bothSymbols: bothSymbols,
    imperialSymbols: imperialSymbols,
  };

  return (
    <UnitContext.Provider value={context}>
      {props.children}
    </UnitContext.Provider>
  );
}

export default UnitContext;